// Import libraries
import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
// Import local modules
import './i18n';
import './styles/index.scss';
import App from './App';
import reportWebVitals from './reportWebVitals';
import store, { persistor } from './redux/store';
import { suppressRecaptchaTimeoutErrors } from './utils/suppressRecaptchaTimeoutErrors';

suppressRecaptchaTimeoutErrors();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <App />
    </PersistGate>
  </Provider>
);

reportWebVitals(); // Passing nothing since we're not using this
